// extracted by mini-css-extract-plugin
export default {"formContainer":"ProfileSettingsForm_formContainer__dEwPn","title":"ProfileSettingsForm_title__jYdqa","formFields":"ProfileSettingsForm_formFields__TCWr7"};